export enum EAdTypes {
  ADSGRAM_V = "adsgram-v",
  ONCLICKA_V = "onclicka-v",
  GIGA_V = "giga-v",
}
